import Vue from 'vue'
// import Router from 'vue-router'
import LangRouter from 'vue-lang-router'
import translations from '@/locales/translations'
import localizedURLs from '@/locales/localized-urls'

import Home from '@/components/Views/Home'
import Example from '@/components/Views/Example'
import Academy from '@/components/Views/Academy'
import Course from '@/components/Views/Course'
import Privacy from '@/components/Views/Privacy'
import Terms from '@/components/Views/Terms'
import Contact from '@/components/Views/Contact'
import DedicatedTeams from '@/components/Views/DedicatedTeams'
import Industries from '@/components/Views/Industries'
import Careers from '@/components/Views/Careers'
import About from '@/components/Views/About'
import PageNotFound from '@/components/layout/PageNotFound'

Vue.use(LangRouter, {
  defaultLanguage: 'us',
  translations,
  localizedURLs
});

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/examples',
    name: 'Example',
    component: Example
  },
  {
    path: '/dedicated-teams',
    name: 'DedicatedTeams',
    component: DedicatedTeams
  },
  {
    path: '/industries',
    name: 'Industries',
    component: Industries
  },
  {
    path: '/careers',
    name: 'Careers',
    component: Careers
  },
  {
    path: '/about-us',
    name: 'About',
    component: About
  },
  {
    path: '/academy',
    name: 'Academy',
    component: Academy
  }, {
    path: '/course-detail/:course_id/:slug',
    name: 'Course',
    component: Course
  }, {
    path: '/privacy-policy',
    name: 'Privacy',
    component: Privacy
  }, {
    path: '/terms',
    name: 'Terms',
    component: Terms
  }, {
    path: '/hire-us',
    name: 'Hire us',
    component: Contact
  }, {
    path: '*',
    name: 'PageNotFound',
    component: PageNotFound
  }
]

// Vue.use(Router)
// export default new LangRouter({
//   mode: 'history',
//   linkExactActiveClass: "router-exact-link",
//   linkActiveClass: "router-active-link",
//   scrollBehavior() {
//     return { x: 0, y: 0 };
//   },
  
// })

// Initiate router
const router = new LangRouter({
  routes,
  mode: "history",
  linkExactActiveClass: "router-exact-link",
  linkActiveClass: "router-active-link",
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js